import {Controller} from "@/controllers/Controller";

/**
 * Controller for invoice API
 */
export class InvoiceController extends Controller {

    static list(){
        return this.requestBuilder("GET",`/ms-transmission/invoice`, true);
    }

    // invoiceId est l'id du business. documentType (invoice par défaut, deposit, credit-note) et creditNoteNumber précisent le document à transmettre
    static create(invoiceId, documentType, creditNoteNumber){
        return this.requestBuilder("POST",`/ms-transmission/invoice/${invoiceId}`, true, {documentType, creditNoteNumber});
    }

    static convert(body){
        return this.requestBuilder("POST",`/ms-transmission/invoice/convert`, true, body);
    }

    static generateTest(){
        return this.requestBuilder("GET",`/ms-transmission/invoice/generate-test`, true);
    }

    static get(id){
        return this.requestBuilder("GET",`/ms-transmission/invoice/${id}`, true);
    }

    static download(id){
        // Fichier brut (blob) : PDF ou XML selon ce que l'émetteur a déposé
        return this.requestBuilder("GET",`/ms-transmission/invoice/${id}/download`, true, undefined, {'Accept': 'application/pdf'});
    }

    static listEvents(params){
        return this.requestBuilder("GET",`/ms-transmission/invoice/events`, true, params);
    }

    static createEvent(body){
        return this.requestBuilder("POST",`/ms-transmission/invoice/events`, true, body);
    }

    static refresh(associationId){
        return this.requestBuilder("POST", `/ms-transmission/invoice/refresh/${associationId}`, true);
    }

    static refreshAll(){
        return this.requestBuilder("POST", `/ms-transmission/invoice/refresh`, true);
    }

}